var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotYet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 128,
    viewBox: "0 0 138 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.4593 7.23429C79.3168 -4.45503 70.3654 1.39343 52.7059 11.402C35.0465 21.4105 14.3297 23.6313 2.35895 50.592C-9.61177 77.5528 33.9361 142.608 86.2985 124.538C138.661 106.468 137.102 30.8335 98.4593 7.23429Z",
    fill: "#E9F2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0007 16.5806C75.5002 16.5806 76.7158 15.365 76.7158 13.8655C76.7158 12.366 75.5002 11.1504 74.0007 11.1504C72.5012 11.1504 71.2856 12.366 71.2856 13.8655C71.2856 15.365 72.5012 16.5806 74.0007 16.5806Z",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.706 75.9629H136.722",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.718 72.9512V78.9745",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1429 112.096H57.5277",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8315 108.407V115.784",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5923 73.1113V32.7424C56.5923 29.3809 59.315 26.6582 62.6766 26.6582H99.0678C102.429 26.6582 105.152 29.3809 105.152 32.7424V75.3472V81.4467V88.2382V94.1703C105.152 94.7787 104.939 95.3643 104.566 95.7978L100.68 99.1061L95.6835 95.1286L90.6564 99.1366L85.6293 95.1362L80.625 99.129L75.6512 95.1362L70.7382 99.0833L65.8327 95.1362L60.973 99.0453L57.1703 95.8055C56.7977 95.372 56.5847 94.794 56.5847 94.1855V72.3508",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.152 88.2458V94.178C105.152 94.7864 104.939 95.372 104.566 95.8055L101.631 98.3076C101.076 98.7792 100.269 98.7944 99.699 98.3381L96.6265 95.8968C96.0713 95.4556 95.2879 95.4556 94.7328 95.8968L91.5994 98.3913C91.0442 98.8324 90.2608 98.8324 89.7057 98.3913L86.5875 95.9044C86.0323 95.4632 85.2414 95.4632 84.6862 95.9044L81.5832 98.3837C81.028 98.8248 80.2371 98.8248 79.6819 98.3837L76.6094 95.912C76.0542 95.4633 75.2632 95.4633 74.708 95.912L71.6963 98.3304C71.1412 98.7792 70.3502 98.7792 69.7874 98.3304L66.7909 95.9196C66.2358 95.4709 65.4372 95.4709 64.882 95.9196L61.9616 98.2696C61.3912 98.7259 60.5774 98.7183 60.0222 98.2392L57.1855 95.8131C56.8128 95.3796 56.5999 94.8016 56.5999 94.1932V72.3584",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5923 73.1113V32.7424C56.5923 29.3809 59.315 26.6582 62.6765 26.6582H99.0678C102.429 26.6582 105.152 29.3809 105.152 32.7424V75.3472",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8688 52.2803C84.8688 52.2803 81.8875 56.0221 78.2065 52.402",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0085 48.188C77.3694 48.188 78.4727 47.0848 78.4727 45.7239C78.4727 44.363 77.3694 43.2598 76.0085 43.2598C74.6477 43.2598 73.5444 44.363 73.5444 45.7239C73.5444 47.0848 74.6477 48.188 76.0085 48.188Z",
    fill: "#6895F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2985 48.188C87.6594 48.188 88.7626 47.0848 88.7626 45.7239C88.7626 44.363 87.6594 43.2598 86.2985 43.2598C84.9376 43.2598 83.8344 44.363 83.8344 45.7239C83.8344 47.0848 84.9376 48.188 86.2985 48.188Z",
    fill: "#6895F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6906 53.9838C92.9339 53.9838 93.9418 52.9759 93.9418 51.7326C93.9418 50.4893 92.9339 49.4814 91.6906 49.4814C90.4473 49.4814 89.4395 50.4893 89.4395 51.7326C89.4395 52.9759 90.4473 53.9838 91.6906 53.9838Z",
    fill: "#FD6F7B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.088 53.8549C72.3312 53.8549 73.3391 52.847 73.3391 51.6037C73.3391 50.3604 72.3312 49.3525 71.088 49.3525C69.8447 49.3525 68.8368 50.3604 68.8368 51.6037C68.8368 52.847 69.8447 53.8549 71.088 53.8549Z",
    fill: "#FD6F7B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7281 38.6973C85.7281 38.6973 86.5571 40.4085 88.9376 40.7735",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7196 39.1836C75.7196 39.1836 74.8906 40.8948 72.5101 41.2598",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6995 68.418H98.0791",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6995 76.4121H98.0791",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1392 84.4043H98.0791",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6995 84.4043H82.5415",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8444 76.5639L18.8244 51.1471C17.6532 48.4472 18.8928 45.3138 21.5927 44.1426L43.4959 34.6436C46.1958 33.4724 49.3292 34.712 50.5004 37.4119L62.1593 64.289L63.8857 68.2666L65.8098 72.7004L67.4906 76.5715C67.6655 76.967 67.6883 77.4081 67.5667 77.796L65.9695 81.0586L61.5813 79.8798L59.429 83.9182L55.0255 82.7242L52.8961 86.7474L48.523 85.5458L46.4316 89.5081L42.1194 88.3217L40.0583 92.246L36.6664 91.2041C36.3013 91.0292 35.9971 90.7098 35.8298 90.3143L29.6543 76.0696",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2431 64.8057L67.5668 77.0882C67.7417 77.4837 67.7645 77.9248 67.6428 78.3126L66.3195 81.0125C66.1598 81.3396 65.7872 81.5069 65.4373 81.4156L62.2431 80.5562C61.9009 80.4649 61.5434 80.617 61.3761 80.9365L59.7942 83.9025C59.6269 84.2143 59.2694 84.3741 58.9272 84.2828L55.6949 83.4082C55.3527 83.3169 54.9877 83.469 54.8203 83.7885L53.2613 86.7317C53.0939 87.0435 52.7289 87.2032 52.3866 87.112L49.1848 86.2374C48.8426 86.1461 48.4775 86.2982 48.3102 86.6176L46.7892 89.5C46.6218 89.8194 46.2568 89.9715 45.9145 89.8803L42.7812 89.0209C42.4389 88.9296 42.0739 89.0817 41.9066 89.4012L40.4235 92.2303C40.2562 92.5573 39.876 92.7094 39.5261 92.603L36.735 91.7436C36.3699 91.5687 36.0657 91.2492 35.8984 90.8538L29.7229 76.6091",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9282 77.0802L18.6039 50.9636C17.6 48.6516 18.6647 45.9669 20.9767 44.963L44.2869 34.8556C46.5989 33.8517 49.2836 34.9164 50.2875 37.2285L62.2506 64.8052",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5447 74.8907L55.961 66.4717",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0316 80.2902L58.4479 71.8711",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8601 57.8701L37.9822 58.8892L35.3203 62.3877",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3401 53.2461L42.127 56.6761L46.576 56.8738",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2108 60.4785C44.2108 60.4785 43.4807 63.6803 40.1344 62.5319",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotYet);
export default __webpack_public_path__ + "static/media/not-yet.415a3f40e3f3a7574c37646b0803a390.svg";
export { ForwardRef as ReactComponent };